import Cookies from "js-cookie";

export function authMiddleware(to, from, next) {
  const raw = Cookies.get("auth");
  let authData = null;

  if (raw) {
    try {
      authData = JSON.parse(raw);
    } catch (e) {
      authData = null;
    }
  }

  if (authData && authData.isAdmin) {
    next();
  } else {
    next("/login");
  }
}
